<template lang="html">
  <div class="">
    <div class="page-drawer">      
      <div class="content-box">
        <div class="search-content">
              <div class="search-content-fields">
                  <el-form ref='searchForm' inline>                    
                    <el-form-item>
                      <el-button type="primary" plain @click="handleSaveClick" >保存</el-button>
                    </el-form-item>
                  </el-form>                
              </div>
          </div>
          <div class="search-result">
            <el-tree
              :props="menuTreeProps"
              :data="menuData"
              node-key="id"
              show-checkbox
              ref="menuTree"
            >
            </el-tree>
          </div>
      </div>
    </div>
    <common-confirm :dialogVisiable.sync="confirmSaveVisible" :confirm="handlerSaveConfirmOK" appendToDialog>
        <div>
          确认保存？
        </div>
    </common-confirm>
  </div>
</template>
<script>
import menulistApi from '@/api/sysmanagement/menulist';
import roleApi from '@/api/sysmanagement/role';

export default {
  props: {
    'roleId': {
      type: String,
      required: true
    },
    'afterSave': {
      type: Function,
      required: false
    }
  },
  data() {
    return {
      menuData: [],
      menuTreeProps: {
            label: 'name',
            children: 'children'
        },
      defaultCheckedKeys: [],
      confirmSaveVisible: false,
    }
  },
  methods: {
    loadMenu() {
      menulistApi.list({})
        .then(res => {
          this.menuData = res;
        })      
    },
    refreshRolePrivilege() {
      roleApi.queryRolePrivilege({roleId: this.roleId})
          .then(res => {
            this.defaultCheckedKeys = res;
            this.$refs['menuTree'].setCheckedKeys(res)
          })
    },
    handleSaveClick() {
      this.confirmSaveVisible = true;
    },
    handlerSaveConfirmOK() {
      let params = {
        roleId: this.roleId,
        permissionIds: this.$refs['menuTree'].getCheckedKeys().join(','),
        lastpermissionIds: this.defaultCheckedKeys.join(',')
      }
     
      roleApi.saveRolePrivilege(params)
            .then(res => {
              this.$message.success('保存角色权限成功');
              if(this.afterSave) {
                this.afterSave();
              }
            })
     
    },
  },
  mounted() {    
    this.loadMenu();  
  }
};
</script>

<style lang="less" scoped>
  .page-drawer {
    width: 800px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
  }

</style>



// WEBPACK FOOTER //
// roleprivilege.vue?4d9a0392